import React from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import PropTypes from "prop-types";
import ReactCountryFlag from "react-country-flag";
import CustomCheckBox from "../../../components/CheckBox/index";
import trashIcon from "../../../assets/images/trash.svg";

const AccesTable = ({
  accesslists,
  paginationOnchange,
  paginationFisrt,
  paginationRows,
  hanleChangeUpdateAccess,
  updatEntity,
  openDeleteModal,
  hanleUpdatePayrollPlus,
}) => {
  const convertToTreeNodes = (data) => {
    return data.map((entity) => ({
      key: `entity-${entity.id}`,
      data: {
        name: (
          <span>
            <ReactCountryFlag
              countryCode={entity.country}
              svg
              className="mr-2"
            />
            {`${entity.name} (${entity.country})`}
          </span>
        ),
        status: null,
        action: (
          <img
            src={trashIcon}
            alt="Delete"
            className="delete-access"
            onClick={() => openDeleteModal(entity)}
          />
        ),
      },
      children: entity.services?.map((service) => {
        if (service?.name === "Payroll +") {
          const templateIds = (service.process_templates || []).map(
            (data) => data.id,
          );
          const checkStates = templateIds.map((id) => {
            const rec = updatEntity?.find(
              (x) =>
                x.entityId === entity.id &&
                x.serviceId === service.id &&
                x.processId === id,
            );
            return rec ? !!rec.checked : true;
          });
          const allSelected =
            checkStates.length > 0 && checkStates.every(Boolean);
          const someSelected =
            checkStates.length > 0 && checkStates.some(Boolean) && !allSelected;

          const payrollChild = {
            key: `process-payrollplus-${service.id}`,
            data: {
              name: "Payroll + (Payslip Integration)",
              status: (
                <div className="flex text-center checkbox-margin">
                  <CustomCheckBox
                    inputId={`checkbox-payrollplus-${entity.id}-${service.id}`}
                    checked={!!allSelected}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      hanleUpdatePayrollPlus(
                        checked,
                        entity.id,
                        service.id,
                        templateIds,
                      );
                    }}
                  />
                </div>
              ),
              action: null,
            },
          };

          return {
            key: `service-${service.id}`,
            data: {
              name: "Payroll +",
              status: null,
              action: null,
            },
            children: [payrollChild],
          };
        }

        return {
          key: `service-${service.id}`,
          data: {
            name: service.name,
            status: null,
            action: null,
          },
          children: service.process_templates?.map((process) => {
            const isAvailable = updatEntity?.find(
              (x) =>
                x.entityId == entity.id &&
                x.serviceId == service.id &&
                x.processId == process.id,
            );
            const isChecked = isAvailable ? isAvailable.checked : true;
            return {
              key: `process-${process.id}`,
              data: {
                name: process.name,
                status: (
                  <div className="flex  text-center checkbox-margin">
                    <CustomCheckBox
                      inputId={`checkbox-${process.id}`}
                      checked={isChecked}
                      onChange={(e) =>
                        hanleChangeUpdateAccess(
                          e.target.checked,
                          entity.id,
                          service.id,
                          process.id,
                        )
                      }
                    />
                  </div>
                ),
                action: null,
              },
            };
          }),
        };
      }),
    }));
  };

  const treeNodes = convertToTreeNodes(accesslists || []);

  return (
    <div className="user-access-table">
      <TreeTable
        value={treeNodes}
        emptyMessage="No results were found"
        responsiveLayout="scroll"
        paginator={accesslists?.length > 10}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        rowsPerPageOptions={[10, 20, 30]}
        first={paginationFisrt}
        rows={paginationRows}
        onPage={paginationOnchange}
      >
        <Column
          field="name"
          header="Entity"
          expander
          className="table-entity-column"
        />
        <Column
          field="status"
          header="Status"
          headerClassName="table-status-header"
        />
        <Column field="action" />
      </TreeTable>
    </div>
  );
};

AccesTable.propTypes = {
  accesslists: PropTypes.array,
  paginationOnchange: PropTypes.func,
  paginationFisrt: PropTypes.number,
  paginationRows: PropTypes.number,
  hanleChangeUpdateAccess: PropTypes.func,
  updatEntity: PropTypes.array,
  openDeleteModal: PropTypes.func,
};

export default AccesTable;
